import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@localagent/ui/components/table';
import { Badge } from '@localagent/ui/components/badge';
import type { ExecutionLogEntry } from '../../types/integrations-types';

function displayValue(value: unknown, fallback = '-'): string {
  if (value == null) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return value.toString();
  return fallback;
}

export function ExecutionLogTable({ logs }: { logs: ExecutionLogEntry[] }) {
  if (logs.length === 0) {
    return <p className="py-8 text-center text-body text-muted-foreground">No execution logs found.</p>;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Timestamp</TableHead>
          <TableHead>Action</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>HTTP</TableHead>
          <TableHead>Duration</TableHead>
          <TableHead>Trigger</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {logs.map((log) => {
          const props = log.properties;
          return (
            <TableRow key={log.id}>
              <TableCell className="text-muted-foreground">{new Date(log.created_at).toLocaleString()}</TableCell>
              <TableCell>{displayValue(props.action_key)}</TableCell>
              <TableCell>
                <Badge variant={props.status === 'success' ? 'success' : 'destructive'}>
                  {displayValue(props.status)}
                </Badge>
              </TableCell>
              <TableCell>{displayValue(props.http_status_code)}</TableCell>
              <TableCell>{props.duration_ms != null ? `${displayValue(props.duration_ms)}ms` : '-'}</TableCell>
              <TableCell className="text-muted-foreground">{displayValue(props.triggered_by)}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
